<template>
  <div class="row" style="height: 100%">
    <div class="col-3 pe-1">
      <b-button
          :class="{'pill': true,'active': value === firstButton.value}"
          block
          @click="onClick(firstButton.value)">
        <div>
          {{ firstButton.label }}
        </div>

      </b-button>
    </div>
    <div class="col-4 px-1">
      <b-button
          :class="{'pill': true,'active': value === secondButton.value}"
          block
          @click="onClick(secondButton.value)">
        {{ secondButton.label }}
      </b-button>
    </div>
    <div class="col-5 ps-1">
      <b-button
          :class="{'pill': true,'active': value === thirdButton.value}"
          block
          @click="onClick(thirdButton.value)">
        <div style="overflow: hidden; text-overflow: ellipsis">
          {{ thirdButton.label }}
        </div>

      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pill-button',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: String,
      default: 'button 1'
    },
    firstButton: {
      type: Object,
      default() {
        return {
          value: 'button 1',
          label: 'button 1',
        }
      }
    },
    secondButton: {
      type: Object,
      default() {
        return {
          value: 'button 2',
          label: 'button 2',
        }
      }
    },
    thirdButton: {
      type: Object,
      default() {
        return {
          value: 'button 3',
          label: 'button 3',
        }
      }
    },
  },
  methods: {
    onClick(value) {
      this.$emit('change', value)
    }
  }
}
</script>

<style lang="scss" scoped>
.button-pills {
  .col-6 {
    padding: 0 6px;
  }
}
button.pill {
  height: 100%;
  font-family: Lato,sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 17px;
  text-align: center;
  color: #636A81 !important;
  background-color: #FFFFFF;
  border: 0;
  border-radius: 5px;
}
button.pill.active {
  color: #FFFFFF !important;
  background-color: #0084F3;
}
</style>